import React, { useContext, useEffect } from 'react';
import { LanguageContext } from "../../context/LanguageContext";

const PricingComparison = () => {
  const { componentLanguageData, loadLanguageFile, language } = useContext(LanguageContext);

  useEffect(() => {
    loadLanguageFile("PricingComparison", "home/home_PricingComparison_lang");
  }, [language]);

  const L = (componentLanguageData.PricingComparison || { Main: {} }).Main;

  // 欄位順序：Free / 30-Day Trial / Starter / Pro
  // 每個 cell 可為數值字串，或特殊 token：check / dash / unlimited / cannotrun
  const sections = [
    {
      title: L.Sec1,    // 策略精靈
      rows: [
        { label: L.Row1, unit: L.Times, cells: ['1', '3', '10', '30'] },
        { label: L.Row2, unit: L.Items, cells: ['1', '1', '5', '20'] },
        { label: L.Row3, unit: L.Items, cells: ['cannotrun', '1', '1', 'unlimited'] },
      ]
    },
    {
      title: L.Sec2,    // AI 策略助理
      rows: [
        { label: L.Row4, unit: L.TimesPerDay, cells: ['2', '10', '30', '60'] },
        { label: L.Row5, unit: L.TimesPerDay, cells: ['1', '5', '15', '30'] },
        { label: L.Row6, unit: L.TimesPerDay, cells: ['6', '10', '20', '50'] },
        { label: L.Row7, unit: L.TimesPerDay, cells: ['3', '5', '10', '25'] },
        { label: L.Row8, unit: L.Items, cells: ['1', '5', '10', '50'] },
      ]
    },
    {
      title: L.Sec3,    // MASLIB 數據中心
      rows: [
        { label: L.Row9, cells: ['check', 'check', 'check', 'check'] },
        { label: L.Row10, cells: ['dash', 'check', 'check', 'check'] },
        { label: L.Row11, cells: ['dash', 'check', 'check', 'check'] },
        { label: L.Row12, cells: ['dash', 'check', 'check', 'check'] },
      ]
    }
  ];

  const renderCell = (v, unit) => {
    if (v === 'check') return <span className="cmp-check">✓</span>;
    if (v === 'dash') return <span className="cmp-dash">—</span>;
    if (v === 'unlimited') return <span className="cmp-unlimited">{L.Unlimited}</span>;
    if (v === 'cannotrun') return <span className="cmp-cannotrun">{L.CannotRun}</span>;
    return <span>{v}{unit ? ' ' + unit : ''}</span>;
  };

  return (
    <div className="container px-lg-5 mt-5">
      <h3 className="pricing-cmp-title">📊 {L.TableTitle}</h3>
      <div className="pricing-cmp-wrap">
        <table className="pricing-cmp">
          <thead>
            <tr>
              <th className="cmp-feature-col">{L.ColFeature}</th>
              <th>{L.ColFree}</th>
              <th>{L.ColTrial}</th>
              <th>{L.ColStarter}</th>
              <th className="cmp-pro">{L.ColPro}</th>
            </tr>
          </thead>
          <tbody>
            {sections.map((sec, si) => (
              <React.Fragment key={si}>
                <tr className="cmp-section"><td colSpan={5}>{sec.title}</td></tr>
                {sec.rows.map((row, ri) => (
                  <tr key={ri}>
                    <td className="cmp-feature">{row.label}</td>
                    <td>{renderCell(row.cells[0], row.unit)}</td>
                    <td>{renderCell(row.cells[1], row.unit)}</td>
                    <td>{renderCell(row.cells[2], row.unit)}</td>
                    <td className="cmp-pro">{renderCell(row.cells[3], row.unit)}</td>
                  </tr>
                ))}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PricingComparison;
